import TabbedDisplay from './TabbedDisplay';

export default TabbedDisplay;
